import { useState } from "react";
import BaseInput from "../BaseInput";

const formatMoney = (value) => {
    if (!value) return value || "0,00";

    value = `${value}`;

    // Remove all non-digits
    const digits = value?.replace(/\D/g, "") || "0";

    // Convert to number and divide by 100 to get the correct decimal places
    const amount = parseInt(digits, 10) / 100;

    // Format as decimal (without currency symbol)
    return new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

const MoneyInput = ({ value, onInput, label = 'Valor', start = "R$", placeholder = '0,00', variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value ? formatMoney(value) : "0,00");

    const handleChange = (newValue) => {
        // Remove all non-digits
        const digits = newValue.replace(/\D/g, "");

        // Format the display value
        const displayValue = formatMoney(digits);
        setLocalValue(displayValue);

        // Send only the digits to parent
        onInput(digits);
    };

    return (
        <BaseInput
            {...props}
            start={start}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
        />
    );
};

export default MoneyInput;
